/*
 * Registro dos módulos auxiliares (BM-2, e os que entrarem a seguir na
 * ordem de construção — ver docs/specs/cma-modulos-auxiliares-3d.md, §3 e
 * §4) que ficam lado a lado na parede de montagem ao lado do transformador.
 *
 * Puro (sem THREE), no mesmo espírito de transformer3dModels.js: só id e
 * ordem. A geometria de cada módulo mora em
 * domain/components/cma/models/paineis/<id>.js; quem liga um ao outro e
 * calcula o leiaute é models/paineis/index.js.
 */

/*
 * Canto inferior-esquerdo da parede, em unidades de cena (mesmo sistema de
 * coordenadas do transformador — ver TFMP_MESH.alturaAlvo). As três
 * coordenadas são ESTIMATIVAS a calibrar visualmente contra a malha do CAD
 * quando o BM-2 (1º módulo) entrar na cena: não há bounding box do tanque
 * isolada do resto do modelo ainda (ver §3.2/§7.1 da spec). X e Z têm folga
 * de sobra — a face escolhida (normal -Z) mede ~10,13 de largura, e os 8
 * módulos, já na escala de presença abaixo, não devem passar de ~9-10
 * unidades somados.
 */
export const AUX_PANEL_ORIGIN = { x: -6.6, y: 1.4, z: -4.4 };
export const AUX_PANEL_MARGIN = 0.5; // vão entre módulos vizinhos, já na escala de presença

/*
 * Fator de PRESENÇA, não de realismo — ver §3.4 da spec (seção "correção").
 * As medidas de cada módulo (§5 da spec, builders em models/paineis/*.js)
 * são o tamanho FÍSICO real de uma caixa de trilho DIN (~15-20 cm de lado),
 * e nessa escala um módulo mede ~6 px no enquadramento de repouso —
 * ilegível. `buildAuxPanelWall` aplica este fator uma vez, sobre o grupo
 * inteiro de cada módulo, para a família toda crescer junta mantendo a
 * proporção relativa das fotos. 6,2× leva a altura do BM-2 (0,194 físico) a
 * ≈ 1,20 — cerca de 6% da altura do quadro de repouso (19,33 unidades) e
 * ~12,6% da altura do transformador (9,5), uma leitura de "armário de
 * controle" plausível ao lado do tanque. Primeiro palpite, não medido
 * contra o transformador renderizado — calibrar em tela (§7).
 */
export const ESCALA_PRESENCA = 6.2;

/*
 * Ordem de entrega = ordem física da esquerda para a direita na parede (ver
 * §4 da spec). Só ids: a geometria de cada um mora em models/paineis/.
 */
export const AUX_PANEL_MODULES = [
  'bm2',
];
